import { render } from "./loading-wrapper.vue?vue&type=template&id=128083f6&ts=true"
import script from "./loading-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./loading-wrapper.ts?vue&type=script&lang=ts&external"

import "./loading-wrapper.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__